import { PlayerBurstConfig } from "../../GameConfig/PlayerConfig.js";
import Burst from "../burst.js";

export default class BaseEngineBurst extends Burst {
  constructor() {
    super();

    this.image.src = PlayerBurstConfig.BASE.IMG_SRC;
    this.maxFrame = PlayerBurstConfig.BASE.MAX_FRAME;

    this.burstSpeed = PlayerBurstConfig.BASE.BURST_SPEED;
  }
}
